import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Pagination from "react-js-pagination";
import Select from "react-select";
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import swal from "sweetalert";

import {
  CheckPermission,
  LoadingSpinner,
  applyClassToCharacters,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString, NoResult } from "../helper/Components";
import { addMember } from "../member/ApiMember";
import AdminModal from "./AdminModal";
import { ApiUser } from "./ApiUsers";
import NonRafiqUserNameModal from "./NonRafiqUserNameModal";
import SearchUsers from "./SearchUsers";
import UsersCredential from "./UsersCredential";
import { ApiUnit } from "../unit/ApiUnit";
import AddNonRafiqUserModal from "./AddNonRafiqUserModal";
import EditNonRafiqUserModal from "./EditNonRafiqUserModal";
import {
  GetCustomStyles,
  GetFooTableCustomStyles,
  GetSelectedLanguage,
} from "../helper/Method";
import { IoAdd } from "react-icons/io5";

const initialValues = {
  name: "neutral",
};

const Users = () => {
  const [loading, setLoading] = useState(false);
  const [nonRafiqLoading, setNonRafiqLoading] = useState(false);
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const memberId = parseInt(encryptStorage.getItem("memberId"));
  const isIncharge = encryptStorage.getItem("canManage");
  const { t } = useTranslation();
  const [members, setMembers] = useState([]);
  const [nonRafiqUsers, setNonRafiqUsers] = useState([]);
  const [modal, setModal] = useState(false);
  const [adminModal, setAdminModal] = useState(false);
  const [nonRafiqUserNameModal, setNonRafiqUserNameModal] = useState(false);
  const [selectedNonRafiqUserId, setSelectedNonRafiqUserId] = useState(0);
  const [showAddNonRafiqModal, setShowAddNonRafiqModal] = useState(false);
  const [showEditNonRafiqModal, setShowEditNonRafiqModal] = useState(false);
  const [editNonRafiqUserId, setEditNonRafiqUserId] = useState(0);
  const newPasswordRequest = { regNo: "" };
  const [pagination, setPagination] = useState({ activePage: 1 });
  const [nonRafiqPagination, setNonRafiqPagination] = useState({
    activePage: 1,
  });
  const [searchButton, setSearchButton] = useState(false);
  const [nonRafiqSearchButton, setNonRafiqSearchButton] = useState(false);
  const [unit, setUnit] = useState({ unitId: loggedInUnitId, unitName: "" });
  const [nonRafiqUnit, setNonRafiqUnit] = useState({
    unitId: loggedInUnitId,
    unitName: "",
  });
  const [nonRafiqUnitList, setNonRafiqUnitList] = useState([]);
  const [values, setValues] = useState({ id: "", username: "", password: "" });
  const [removeAdmin, setRemoveAdmin] = useState(false);
  const [searchMemberModel, setSearchMemberModel] = useState({
    unitId: loggedInUnitId,
    activePage: 1,
    isSubUnits: true,
  });
  const [nonRafiqSearchModel, setNonRafiqSearchModel] = useState({
    unitId: loggedInUnitId,
    activePage: 1,
    isSubUnits: true,
  });
  const [nonRafiqSearchValues, setNonRafiqSearchValues] = useState({
    name: "",
    address: "",
    phone: "",
    phoneNo: "",
    unitId: loggedInUnitId,
    activePage: 1,
    isSubUnits: true,
  });
  const [activeTab, setActiveTab] = useState("rufaqa");
  const unitTypeName = "null";
  let recordIndex = pagination.pageSize * (pagination.activePage - 1) + 1;
  let nonRafiqRecordIndex =
    nonRafiqPagination.pageSize * (nonRafiqPagination.activePage - 1) + 1;
  const [sortObject, setSortObject] = useState(initialValues);

  const toggleDropdownOpen = (index) => {
    setMembers((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, dropDown: !item.dropDown } : item
      )
    );
  };

  const toggleNonRafiqDropdownOpen = (index) => {
    setNonRafiqUsers((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, dropDown: !item.dropDown } : item
      )
    );
  };

  const handleSorting = (name) => {
    if (sortObject[name] === "neutral" || sortObject[name] === "descending") {
      setSortObject({
        ...initialValues,
        [name]: "ascending",
      });
    } else if (sortObject[name] === "ascending") {
      setSortObject({
        ...initialValues,
        [name]: "descending",
      });
    }
  };

  useEffect(() => {
    if (unit.unitId === 0) {
      ApiUnit()
        .getUnitList(0, loggedInUnitId, false, unitTypeName)
        .then((res) => {
          let temp = res.data[0].unitList[0];
          setSearchMemberModel({
            unitId: temp.id,
            activePage: 1,
          });
          setUnit({ unitId: temp.id, unitName: temp.name });
        })
        .catch((err) => console.log(err));
    }
  }, [unit.unitId, loggedInUnitId]);

  useEffect(() => {
    ApiUnit()
      .getUnitList(nonRafiqUnit.unitId, loggedInUnitId, false, unitTypeName)
      .then((res) => {
        setNonRafiqUnitList(res.data);

        if (nonRafiqUnit.unitId === 0) {
          let temp = res.data[0]?.unitList[0];
          if (temp) {
            setNonRafiqSearchModel((prev) => ({
              ...prev,
              unitId: temp.id,
              activePage: 1,
            }));
            setNonRafiqSearchValues((prev) => ({
              ...prev,
              unitId: temp.id,
              activePage: 1,
            }));
            setNonRafiqUnit({ unitId: temp.id, unitName: temp.name });
          }
        }
      })
      .catch((err) => console.log(err));
  }, [nonRafiqUnit.unitId, loggedInUnitId]);

  const ApiRequest = useCallback(() => {
    setLoading(true);
    let tempSortObject = {
      isFullNameDescending: sortObject.name === "descending",
      isFullNameAscending: sortObject.name === "ascending",
    };
    searchMemberModel.sortModel = tempSortObject;
    let responsibilities = [];
    if (searchMemberModel.responsibilityId)
      responsibilities.push(searchMemberModel.responsibilityId);

    searchMemberModel.responsibilityIds = responsibilities;

    addMember()
      .getUserMember(searchMemberModel)
      .then((res) => {
        setMembers(res.data.list);
        setPagination(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [searchMemberModel, sortObject]);

  useEffect(() => {
    ApiRequest();
  }, [ApiRequest]);

  const NonRafiqApiRequest = useCallback(() => {
    if (activeTab !== "nonRafiq") return;

    setNonRafiqLoading(true);
    addMember()
      .GetNonRafiqUsers(nonRafiqSearchModel)
      .then((res) => {
        setNonRafiqUsers(res.data.list);
        setNonRafiqPagination(res.data);
        setNonRafiqLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setNonRafiqLoading(false);
      });
  }, [activeTab, nonRafiqSearchModel]);

  useEffect(() => {
    NonRafiqApiRequest();
  }, [NonRafiqApiRequest]);

  const handlePageChange = (pageNumber) => {
    setSearchMemberModel({
      ...searchMemberModel,
      activePage: pageNumber,
    });
    setPagination({
      ...pagination,
      activePage: pageNumber,
    });
  };

  const handleNonRafiqInputChange = (e) => {
    const { name, value } = e.target;
    setNonRafiqSearchValues({
      ...nonRafiqSearchValues,
      [name]: value,
    });
  };

  const handleNonRafiqChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(record.value, loggedInUnitId, false, unitTypeName)
        .then((res) => {
          setNonRafiqUnitList(res.data);
        })
        .catch((err) => console.log(err));

      setNonRafiqUnit({ unitId: record.value, unitName: record.label });
      setNonRafiqSearchValues({
        ...nonRafiqSearchValues,
        unitId: record.value,
      });
    }
  };

  const handleNonRafiqSubUnits = (e) => {
    const { value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setNonRafiqSearchValues({
      ...nonRafiqSearchValues,
      isSubUnits: v,
    });
  };

  const handleNonRafiqSearch = (e) => {
    e.preventDefault();
    const searchModel = {
      ...nonRafiqSearchValues,
      phoneNo: nonRafiqSearchValues.phone,
      activePage: 1,
    };
    setNonRafiqSearchButton(true);
    setNonRafiqSearchModel(searchModel);
    setNonRafiqPagination({
      ...nonRafiqPagination,
      activePage: 1,
    });
  };

  const handleNonRafiqPageChange = (pageNumber) => {
    setNonRafiqSearchModel({
      ...nonRafiqSearchModel,
      activePage: pageNumber,
    });
    setNonRafiqSearchValues({
      ...nonRafiqSearchValues,
      activePage: pageNumber,
    });
    setNonRafiqPagination({
      ...nonRafiqPagination,
      activePage: pageNumber,
    });
  };

  const handleEnableLogin = (idOrEvent) => {
    const value = idOrEvent?.target ? idOrEvent.target.value : idOrEvent;
    let temp = { id: value };
    swal({
      title: t("common_delete_message"),
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      text: t("user_login_will_be_enabled"),
      icon: "success",
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (activeTab === "nonRafiq") setNonRafiqLoading(true);
        else setLoading(true);
        ApiUser()
          .enableUser(temp)
          .then((res) => {
            if (activeTab === "nonRafiq") NonRafiqApiRequest();
            else ApiRequest();
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            setNonRafiqLoading(false);
          });
      }
    });
  };

  const handleOnCreateLogin = (idOrEvent) => {
    const value = idOrEvent?.target ? idOrEvent.target.value : idOrEvent;
    let temp = { id: value };
    setLoading(true);
    ApiUser()
      .createUser(temp)
      .then((res) => {
        setValues(res.data);
        ApiRequest();
        setModal(true);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleOnCreateNonRafiqLogin = (idOrEvent) => {
    const value = idOrEvent?.target ? idOrEvent.target.value : idOrEvent;
    setSelectedNonRafiqUserId(value);
    setNonRafiqUserNameModal(true);
  };

  const handleOnEditNonRafiqUser = (idOrEvent) => {
    const value = idOrEvent?.target ? idOrEvent.target.value : idOrEvent;
    setEditNonRafiqUserId(value);
    setShowEditNonRafiqModal(true);
  };

  const handleSubmitNonRafiqUserName = (username) => {
    let temp = { id: selectedNonRafiqUserId, username };
    setNonRafiqLoading(true);
    ApiUser()
      .createUser(temp)
      .then((res) => {
        setValues(res.data);
        NonRafiqApiRequest();
        setModal(true);
        setNonRafiqUserNameModal(false);
        setSelectedNonRafiqUserId(0);
        setNonRafiqLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setNonRafiqLoading(false);
        const errorList = err?.response?.data?.errors;
        const errorMsg =
          (Array.isArray(errorList) && errorList.length > 0
            ? errorList.join("\n")
            : null) ||
          err?.response?.data?.title ||
          err?.response?.data?.message ||
          (typeof err?.response?.data === "string" ? err.response.data : null) ||
          "Failed to create user";
        swal("Error", errorMsg, "error");
      });
  };

  const handleOnMakeAdmin = (idOrEvent) => {
    const value = idOrEvent?.target ? idOrEvent.target.value : idOrEvent;
    if (activeTab === "nonRafiq") setNonRafiqLoading(true);
    else setLoading(true);
    ApiUser()
      .makeAdmin(value)
      .then((res) => {
        setAdminModal(true);
        if (activeTab === "nonRafiq") NonRafiqApiRequest();
        else ApiRequest();
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setNonRafiqLoading(false);
      });
  };

  const handleOnRemoveAdmin = (idOrEvent) => {
    const value = idOrEvent?.target ? idOrEvent.target.value : idOrEvent;
    if (activeTab === "nonRafiq") setNonRafiqLoading(true);
    else setLoading(true);
    ApiUser()
      .removeAdmin(value)
      .then((res) => {
        setRemoveAdmin(true);
        setAdminModal(true);
        if (activeTab === "nonRafiq") NonRafiqApiRequest();
        else ApiRequest();
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setNonRafiqLoading(false);
      });
  };

  const handleOnDisable = (idOrEvent) => {
    const value = idOrEvent?.target ? idOrEvent.target.value : idOrEvent;
    let temp = { id: value };
    swal({
      title: t("common_delete_message"),
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      text: t("user_login_will_be_disabled"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (activeTab === "nonRafiq") setNonRafiqLoading(true);
        else setLoading(true);
        ApiUser()
          .disableUser(temp)
          .then((res) => {
            if (activeTab === "nonRafiq") NonRafiqApiRequest();
            else ApiRequest();
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            setNonRafiqLoading(false);
          });
      }
    });
  };

  const handleResetPassword = (serialNumberOrEvent) => {
    const value = serialNumberOrEvent?.target
      ? serialNumberOrEvent.target.value
      : serialNumberOrEvent;
    newPasswordRequest.regNo = value;
    ApiUser()
      .resetPassword(newPasswordRequest)
      .then((res) => {
        swal({
          title: t("users_new_password_generated"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          text: t("user_password") + " : " + res.data,
        });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleNonRafiqResetPassword = (record) => {
    const request = {
      regNo: record.serialNumber || record.regNo,
      username: record.username || record.userName,
    };
    ApiUser()
      .resetPassword(request)
      .then((res) => {
        swal({
          title: t("users_new_password_generated"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          text: t("user_password") + " : " + res.data,
        });
      })
      .catch((err) => {
        console.log(err);
        setNonRafiqLoading(false);
      });
  };

  const handleDeleteNonRafiqUser = (id) => {
    swal({
      title: t("common_delete_message"),
      className: GetSelectedLanguage() === "en" ? "" : "ur",
      text: t("common_delete_detail_message"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setNonRafiqLoading(true);
        addMember()
          .DeleteNonRafiqUser(id)
          .then(() => {
            swal({
              title: t("common_delete_success_message"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
            });
            NonRafiqApiRequest();
          })
          .catch((err) => {
            console.log(err);
            setNonRafiqLoading(false);
          });
      }
    });
  };

  return (
    <div>
      {modal ? (
        <UsersCredential
          setModal={setModal}
          values={values}
          setValues={setValues}
        />
      ) : null}
      {adminModal ? (
        <AdminModal
          setModal={setAdminModal}
          removeAdmin={removeAdmin}
          setRemoveAdmin={setRemoveAdmin}
        />
      ) : null}
      {nonRafiqUserNameModal ? (
        <NonRafiqUserNameModal
          setModal={setNonRafiqUserNameModal}
          onSubmit={handleSubmitNonRafiqUserName}
          loading={nonRafiqLoading}
        />
      ) : null}
      {showAddNonRafiqModal ? (
        <AddNonRafiqUserModal
          setModal={setShowAddNonRafiqModal}
          onSaved={NonRafiqApiRequest}
        />
      ) : null}
      {showEditNonRafiqModal ? (
        <EditNonRafiqUserModal
          editValue={editNonRafiqUserId}
          setModal={setShowEditNonRafiqModal}
          onSaved={NonRafiqApiRequest}
        />
      ) : null}
      <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === "rufaqa" ? "active" : ""}
              onClick={() => setActiveTab("rufaqa")}
            >
              {<GetLanguageString props="user_rufaqa_tab" />}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "nonRafiq" ? "active" : ""}
              onClick={() => setActiveTab("nonRafiq")}
            >
              {<GetLanguageString props="user_non_rafiq_users" />}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="rufaqa">
        <div className="ibox ">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="user_search_users" />}</h5>
          </div>
          <div className="ibox-content">
            <SearchUsers
              unitId={unit.unitId}
              setUnit={setUnit}
              searchMemberModel={searchMemberModel}
              setSearchMemberModel={setSearchMemberModel}
              setSearchButton={setSearchButton}
            />
          </div>
        </div>
        {searchButton && (
          <div className="ibox ">
            <div className="ibox-title">
              <h5>{<GetLanguageString props="user_search_list" />}</h5>
            </div>
            <div className="ibox-content">
              {!loading ? (
                members.length !== 0 ? (
                  <div className="table-responsive">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th
                            className="cursor-pointer"
                            onClick={() => handleSorting("name")}
                          >
                            {<GetLanguageString props="common_name" />}
                            <span
                              className={GetFooTableCustomStyles().span_style}
                            >
                              {sortObject.name === "neutral" ? (
                                <>
                                  <i
                                    className={
                                      GetFooTableCustomStyles().up_down_style
                                    }
                                  />
                                  <i
                                    className={
                                      GetFooTableCustomStyles().down_up_style
                                    }
                                  />
                                </>
                              ) : sortObject.name === "ascending" ? (
                                <i
                                  className={GetFooTableCustomStyles().up_style}
                                />
                              ) : (
                                <i
                                  className={
                                    GetFooTableCustomStyles().down_style
                                  }
                                />
                              )}
                            </span>
                          </th>
                          <th>
                            {<GetLanguageString props="member_reg_number" />}
                          </th>
                          <th>
                            {<GetLanguageString props="settings_member_type" />}
                          </th>
                          <th>
                            {<GetLanguageString props="unit_unit_table" />}
                          </th>
                          <th>
                            {
                              <GetLanguageString props="dashboard_event_page_status" />
                            }
                          </th>
                          {isIncharge ? (
                            <th className="text-center">
                              {<GetLanguageString props="common_action" />}
                            </th>
                          ) : null}
                        </tr>
                      </thead>
                      <tbody>
                        {members?.map((record, index) => {
                          return (
                            <tr key={index}>
                              <td className="p-t-custom">
                                {index + recordIndex}
                              </td>
                              <td className="ur p-t-custom">
                                {record.fullName}
                              </td>
                              <td className="p-t-custom">{record.regNo}</td>
                              <td className="ur p-t-custom">
                                {record.memberType}
                              </td>
                              <td>
                                <Button
                                  size="xs"
                                  color="info"
                                  className="label label-info m-r-xs"
                                >
                                  <h5 className="ur">{record.unitName}</h5>
                                </Button>
                              </td>
                              <td>
                                {record.aspNetUsersId == null ? (
                                  "-"
                                ) : record.isUserDisabled ? (
                                  <Label
                                    size="sm"
                                    color="danger"
                                    className="label label-danger m-r-xs"
                                  >
                                    {
                                      <GetLanguageString props="user_account_disabled" />
                                    }
                                  </Label>
                                ) : (
                                  <Label
                                    size="sm"
                                    color="primary"
                                    className="label label-primary m-r-xs"
                                  >
                                    {<GetLanguageString props="user_active" />}
                                  </Label>
                                )}
                              </td>
                              <td className="text-center">
                                {isIncharge && record.canManageCredentials ? (
                                  <Dropdown
                                    isOpen={record.dropDown}
                                    toggle={() => {
                                      toggleDropdownOpen(index);
                                    }}
                                    style={{ position: "static" }}
                                  >
                                    <DropdownToggle
                                      className="btn btn-default"
                                      tag="span"
                                      aria-expanded={record.dropDown}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <GetLanguageString props="common_action" />
                                      <b className="caret m-l-xs" />
                                    </DropdownToggle>
                                    <DropdownMenu
                                      style={{
                                        minWidth: "0rem",
                                        fontSize: "13px",
                                      }}
                                    >
                                      {record.isUserDisabled ? (
                                        <DropdownItem
                                          onClick={() =>
                                            handleEnableLogin(record.id)
                                          }
                                        >
                                          <GetLanguageString props="user_enable_login" />
                                        </DropdownItem>
                                      ) : record.aspNetUsersId == null ? (
                                        CheckPermission("CanCreateUser") ? (
                                          <DropdownItem
                                            onClick={() =>
                                              handleOnCreateLogin(record.id)
                                            }
                                          >
                                            <GetLanguageString props="user_create_login" />
                                          </DropdownItem>
                                        ) : null
                                      ) : (
                                        <>
                                          {CheckPermission(
                                            "CanResetPassword"
                                          ) ? (
                                            <DropdownItem
                                              onClick={() =>
                                                handleResetPassword(
                                                  record.serialNumber
                                                )
                                              }
                                            >
                                              {
                                                <GetLanguageString props="user_re_generate_password" />
                                              }
                                            </DropdownItem>
                                          ) : null}
                                          <DropdownItem
                                            onClick={() =>
                                              handleOnDisable(record.id)
                                            }
                                          >
                                            {
                                              <GetLanguageString props="user_disabled_login" />
                                            }
                                          </DropdownItem>
                                          {memberId === 0 ? (
                                            record.isAdmin ? (
                                              <DropdownItem
                                                onClick={() =>
                                                  handleOnRemoveAdmin(record.id)
                                                }
                                              >
                                                {
                                                  <GetLanguageString props="user_remove_admin" />
                                                }
                                              </DropdownItem>
                                            ) : (
                                              <DropdownItem
                                                onClick={() =>
                                                  handleOnMakeAdmin(record.id)
                                                }
                                              >
                                                {
                                                  <GetLanguageString props="user_make_admin" />
                                                }
                                              </DropdownItem>
                                            )
                                          ) : null}
                                        </>
                                      )}
                                    </DropdownMenu>
                                  </Dropdown>
                                ) : null}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="11">
                            <ul className={GetCustomStyles().page_style}>
                              <Pagination
                                activePage={pagination.activePage}
                                itemsCountPerPage={pagination.pageSize}
                                totalItemsCount={pagination.totalItem}
                                pageRangeDisplayed={pagination.pageRange}
                                onChange={handlePageChange}
                              />
                            </ul>
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                ) : (
                  <NoResult />
                )
              ) : (
                LoadingSpinner()
              )}
            </div>
          </div>
        )}
          </TabPane>
          <TabPane tabId="nonRafiq">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>{<GetLanguageString props="user_non_rafiq_users" />}</h5>
                <Button
                  color="default"
                  size="sm"
                  className={GetCustomStyles().btn_style}
                  onClick={() => setShowAddNonRafiqModal(true)}
                >
                  <IoAdd
                    color="#18A689"
                    size={18}
                    style={{ marginRight: 3, marginBottom: 1 }}
                  />
                  {<GetLanguageString props="member_add_non_rafiq_user" />}
                </Button>
              </div>
              <div className="ibox-content">
                <Form onSubmit={handleNonRafiqSearch}>
                  <Row className="g-2">
                    <Col md="3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {<GetLanguageString props="member_search_by_name" />}
                        </Label>
                        <Input
                          className="ur"
                          type="text"
                          name="name"
                          value={nonRafiqSearchValues.name}
                          onChange={handleNonRafiqInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label className="col-form-label">
                          {
                            <GetLanguageString props="member_search_by_phoneno" />
                          }
                        </Label>
                        <Input
                          type="text"
                          name="phone"
                          value={nonRafiqSearchValues.phone}
                          onChange={handleNonRafiqInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label className="col-form-label">
                          {
                            <GetLanguageString props="member_search_by_address" />
                          }
                        </Label>
                        <Input
                          className="ur"
                          type="text"
                          name="address"
                          value={nonRafiqSearchValues.address}
                          onChange={handleNonRafiqInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="g-2">
                    {nonRafiqUnitList.map((record, index) => {
                      const unitOptions = [];
                      record.unitList.forEach((d) =>
                        unitOptions.push({ value: d.id, label: d.name }),
                      );
                      let selected = {};
                      let unitName = "";
                      if (record.parentUnitName !== null) {
                        unitName = record.parentUnitName;
                      }
                      if (record.selectedUnit !== null) {
                        selected = {
                          value: record.selectedUnit.id,
                          label: record.selectedUnit.name,
                        };
                      }

                      return (
                        <Col md="2" key={index}>
                          <FormGroup>
                            <Label className="col-form-label">
                              {unitName !== "" ? (
                                <GetLanguageString
                                  props="member_select_unit_name"
                                  value={unitName}
                                />
                              ) : (
                                <GetLanguageString props="member_select_unit" />
                              )}
                            </Label>
                            <Select
                              options={unitOptions}
                              value={selected}
                              className="basic-single ur"
                              classNamePrefix="select"
                              onChange={handleNonRafiqChangeUnits}
                            />
                          </FormGroup>
                        </Col>
                      );
                    })}
                  </Row>
                  <Row>
                    <Col md="2">
                      <FormGroup check>
                        <Label check for="nonRafiqSubUnit">
                          <Input
                            id="nonRafiqSubUnit"
                            type="checkbox"
                            name="isSubUnits"
                            checked={nonRafiqSearchValues.isSubUnits}
                            value={!nonRafiqSearchValues.isSubUnits}
                            onChange={handleNonRafiqSubUnits}
                          />
                          {
                            <GetLanguageString props="member_search_member_sub_unit" />
                          }
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <FormGroup>
                        <Button color="primary" className="m-l-sm" type="submit">
                          {<GetLanguageString props="common_search" />}
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
            {nonRafiqSearchButton && (
              <div className="ibox ">
                <div className="ibox-title">
                  <h5>{<GetLanguageString props="user_search_list" />}</h5>
                </div>
                <div className="ibox-content">
                  {!nonRafiqLoading ? (
                    nonRafiqUsers.length !== 0 ? (
                      <div className="table-responsive">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>{<GetLanguageString props="common_name" />}</th>
                              <th>
                                {<GetLanguageString props="user_user_name" />}
                              </th>
                              <th>
                                {<GetLanguageString props="member_phone" />}
                              </th>
                              <th>
                                {<GetLanguageString props="member_address" />}
                              </th>
                              <th>
                                {<GetLanguageString props="unit_unit_table" />}
                              </th>
                              <th>
                                {
                                  <GetLanguageString props="dashboard_event_page_status" />
                                }
                              </th>
                              {isIncharge ? (
                                <th className="text-center">
                                  {<GetLanguageString props="common_action" />}
                                </th>
                              ) : null}
                            </tr>
                          </thead>
                          <tbody>
                            {nonRafiqUsers?.map((record, index) => {
                              return (
                                <tr key={index}>
                                  <td className="p-t-custom">
                                    {index + nonRafiqRecordIndex}
                                  </td>
                                  <td className="p-t-custom">
                                    {applyClassToCharacters(
                                      record.fullName || record.name || "",
                                      "ur",
                                    )}
                                  </td>
                                  <td className="p-t-custom">
                                    {applyClassToCharacters(
                                      record.username || record.userName || "",
                                      "ur",
                                    )}
                                  </td>
                                  <td className="p-t-custom">
                                    {applyClassToCharacters(
                                      record.mobileNumber ||
                                        record.phone ||
                                        record.phoneNo ||
                                        "",
                                      "ur",
                                    )}
                                  </td>
                                  <td className="p-t-custom">
                                    {applyClassToCharacters(
                                      record.currentAddress ||
                                        record.address ||
                                        "",
                                      "ur",
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      size="xs"
                                      color="info"
                                      className="label label-info m-r-xs"
                                    >
                                      <h5>
                                        {applyClassToCharacters(
                                          record.unitName || "",
                                          "ur",
                                        )}
                                      </h5>
                                    </Button>
                                  </td>
                                  <td>
                                    {record.aspNetUsersId == null ? (
                                      "-"
                                    ) : record.isUserDisabled ? (
                                      <Label
                                        size="sm"
                                        color="danger"
                                        className="label label-danger m-r-xs"
                                      >
                                        {
                                          <GetLanguageString props="user_account_disabled" />
                                        }
                                      </Label>
                                    ) : (
                                      <Label
                                        size="sm"
                                        color="primary"
                                        className="label label-primary m-r-xs"
                                      >
                                        {
                                          <GetLanguageString props="user_active" />
                                        }
                                      </Label>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {isIncharge ? (
                                      <Dropdown
                                        isOpen={record.dropDown}
                                        toggle={() => {
                                          toggleNonRafiqDropdownOpen(index);
                                        }}
                                        style={{ position: "static" }}
                                      >
                                        <DropdownToggle
                                          className="btn btn-default"
                                          tag="span"
                                          aria-expanded={record.dropDown}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <GetLanguageString props="common_action" />
                                          <b className="caret m-l-xs" />
                                        </DropdownToggle>
                                        <DropdownMenu
                                          style={{
                                            minWidth: "0rem",
                                            fontSize: "13px",
                                          }}
                                        >
                                          <DropdownItem
                                            onClick={() =>
                                              handleOnEditNonRafiqUser(
                                                record.id
                                              )
                                            }
                                          >
                                            {
                                              <GetLanguageString props="common_edit" />
                                            }
                                          </DropdownItem>
                                          {record.canManageCredentials && (
                                            <>
                                              {record.isUserDisabled ? (
                                                <DropdownItem
                                                  onClick={() =>
                                                    handleEnableLogin(
                                                      record.id
                                                    )
                                                  }
                                                >
                                                  {
                                                    <GetLanguageString props="user_enable_login" />
                                                  }
                                                </DropdownItem>
                                              ) : record.aspNetUsersId ==
                                                null ? (
                                                CheckPermission(
                                                  "CanCreateUser"
                                                ) ? (
                                                  <DropdownItem
                                                    onClick={() =>
                                                      handleOnCreateNonRafiqLogin(
                                                        record.id
                                                      )
                                                    }
                                                  >
                                                    {
                                                      <GetLanguageString props="user_create_login" />
                                                    }
                                                  </DropdownItem>
                                                ) : null
                                              ) : (
                                                <>
                                                  {CheckPermission(
                                                    "CanResetPassword"
                                                  ) ? (
                                                    <DropdownItem
                                                      onClick={() =>
                                                        handleNonRafiqResetPassword(
                                                          record
                                                        )
                                                      }
                                                    >
                                                      {
                                                        <GetLanguageString props="user_re_generate_password" />
                                                      }
                                                    </DropdownItem>
                                                  ) : null}
                                                  <DropdownItem
                                                    onClick={() =>
                                                      handleOnDisable(
                                                        record.id
                                                      )
                                                    }
                                                  >
                                                    {
                                                      <GetLanguageString props="user_disabled_login" />
                                                    }
                                                  </DropdownItem>
                                                  {memberId === 0 ? (
                                                    record.isAdmin ? (
                                                      <DropdownItem
                                                        onClick={() =>
                                                          handleOnRemoveAdmin(
                                                            record.id
                                                          )
                                                        }
                                                      >
                                                        {
                                                          <GetLanguageString props="user_remove_admin" />
                                                        }
                                                      </DropdownItem>
                                                    ) : (
                                                      <DropdownItem
                                                        onClick={() =>
                                                          handleOnMakeAdmin(
                                                            record.id
                                                          )
                                                        }
                                                      >
                                                        {
                                                          <GetLanguageString props="user_make_admin" />
                                                        }
                                                      </DropdownItem>
                                                    )
                                                  ) : null}
                                                </>
                                              )}
                                            </>
                                          )}
                                          <DropdownItem divider />
                                          <DropdownItem
                                            className="text-danger"
                                            onClick={() =>
                                              handleDeleteNonRafiqUser(
                                                record.id
                                              )
                                            }
                                          >
                                            {
                                              <GetLanguageString props="common_delete" />
                                            }
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    ) : null}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colSpan="8">
                                <ul className={GetCustomStyles().page_style}>
                                  <Pagination
                                    activePage={nonRafiqPagination.activePage}
                                    itemsCountPerPage={
                                      nonRafiqPagination.pageSize
                                    }
                                    totalItemsCount={
                                      nonRafiqPagination.totalItem
                                    }
                                    pageRangeDisplayed={
                                      nonRafiqPagination.pageRange
                                    }
                                    onChange={handleNonRafiqPageChange}
                                  />
                                </ul>
                              </td>
                            </tr>
                          </tfoot>
                        </Table>
                      </div>
                    ) : (
                      <NoResult />
                    )
                  ) : (
                    LoadingSpinner()
                  )}
                </div>
              </div>
            )}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default Users;
